var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quota',{attrs:{"domain":_vm.domain,"scene":"domain"}})
}
var staticRenderFns = []

export { render, staticRenderFns }